import apiClient from "./apiClient";

export const getPets = (page = 1, limit = 10, search="") => apiClient
    .get("/pets", { params: { page, limit, search } })
    .then(res => res);

export const getPetsByOfficeId = (id, page = 1, limit = 10, search="") => apiClient
    .get(`/pets/office/${id}`, { params: { page, limit, search } })
    .then(res => res);

export const getPetsByOwnerId = (id, page = 1, limit = 10, search="") => apiClient
    .get(`/pets/owner/${id}`, { params: { page, limit, search } })
    .then(res => res);

export const getPetById = (id) => apiClient.get(`/pets/${id}`);
export const createPet = (data) => apiClient.post("/pets", data);
export const updatePet = (id, data) => apiClient.put(`/pets/${id}`, data);
export const deletePet = (id) => apiClient.delete(`/pets/${id}`);
export const getSpeciesLookup = () => apiClient.get("/pets/lookup/species");

export const getPetVisitRecommendations = (page = 1, limit = 10, search="") => apiClient
    .get("/pets/recommended-visits", { params: { page, limit, search } })
    .then(res => res);
export const getPetVisitRecommendationsByPetId = (id) => apiClient.get(`/pets/recommended-visits/${id}`);